export const chatSectionId = 'chat-section';
